import { forwardRef } from 'react'
import { tm } from '@captaincause/ui/tm'
import type { ReactNode, Ref } from 'react'

interface GiveProjectsGridProps {
  size: number
  children: ReactNode
  className?: string
}

function GiveProjectsGridWithRef(
  { children, size, className = '' }: GiveProjectsGridProps,
  ref: Ref<HTMLDivElement>,
) {
  return (
    <section
      ref={ref}
      className={tm(
        'mx-auto grid h-fit w-full max-w-screen-2xl grid-cols-1 gap-x-10 gap-y-8 py-10 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3',
        size === 0 &&
          'sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-1',
        size === 1 &&
          'sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2',
        size === 2 &&
          'sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2',
        className,
      )}
    >
      {children}
    </section>
  )
}
export const GiveProjectsGrid = forwardRef(GiveProjectsGridWithRef)
